import { HealthNavigatorResponse, Module, MODULE_TYPE, NAVIGATOR_AUTHOR, OTHER_SERVICE } from '@abiglobalhealth/go-types'

import { getSlugTranslation } from '@/locale/utils'

export const getInitialNavigatorMessage = (navigator: HealthNavigatorResponse) => ({
  sender: NAVIGATOR_AUTHOR.HEALTH_NAVIGATOR,
  healthResources: [],
  recommendedActions: [],
  text: getSlugTranslation('navigator.welcome_message', {
    navName: navigator.navigatorName,
    partnerName: navigator.partnerName
  })
})

export const isNavigatorModule = (module: Module | undefined): boolean =>
  module?.type === MODULE_TYPE.CONSULTATION_LANDING && module.consultationType === OTHER_SERVICE.HEALTH_NAVIGATOR
